module.exports = __webpack_public_path__ + "static/media/520.4e095a5d.jpg";